import { render } from "./index.vue?vue&type=template&id=edd7368e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=edd7368e&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edd7368e"],['__file',"src/views/customer/people/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "edd7368e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('edd7368e', __exports__)) {
    console.log('reload')
    api.reload('edd7368e', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=edd7368e&scoped=true", () => {
    console.log('re-render')
    api.rerender('edd7368e', render)
  })

}


export default __exports__